<template lang="pug">
  .component-vehicle-smart-edit
    smart-edit(:options="options", :value="item", @input="updateFields")
    button.button.expanded(v-on:click="edit") Save and Submit
</template>
<script type="text/babel">
  import SmartEdit from "components/structure/SmartEdit"
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import MaggieHelper from "../../../maggieHelper";

  export default {
    name: "VehicleSmartEdit",
    components: {SmartEdit},
    data() {
      return {
        vehicleBrands: null,
        vehicleCategories: null,
        options: {
          translations: {"category.name": "Name"},
          types: {
            picture: 'file',
            brand: [],
            'category.name': [],
            fuel_type: ['PETROL', 'DIESEL', 'HYBRID', 'GAS', 'ELECTRIC', 'HYDROGEN', 'NONE', 'OTHER']
          },
          file: {
            selectedVisibility: 'public',
            selectedPrefix: 'vehicles'
          },
          disabled: [

            /*    "profile_picture",
             "status",
             "created",*/
          ],
          list: [
            "id",
            "uid",
            "hardware",
            "brand_logo",
            "odometer",
            "parking_lot",
            "door_status",
            "engine_status",
            "slot_id",
            "slot_name",
            "slot_disabled",
            "in_range",
            "position",
            "brand_id",
            "fuel_level",
            "category_id",
            "category.id",
            "category.description",
            "category.picture",
            "category.vehicle_type",
            "category.uid",
            "picture_external",
          ],
          listMode: 'blacklist',
        }
      }
    },
    created() {
      KeplerBackofficeSdk.selects.vehicleBrands((data) => {
        this.vehicleBrands = data
        data.forEach((item) => {
          this.options.types.brand.push(item.name)
        })
      })

      KeplerBackofficeSdk.vehicleCategories.list((data) => {
        this.vehicleCategories = data
        data.forEach((item) => {
          this.options.types["category.name"].push(item.name)
        })
      })

    },
    methods: {
      updateFields(item) {
        this.item = item
      },
      edit() {

        var brand_id = null
        var category_id = null
        this.vehicleBrands.forEach((item) => {


          if (item.name === this.item.brand) {
            this.item.brand_id = item.id
          }
        })

        this.vehicleCategories.forEach((item) => {
          if (item.name === this.item.category.name) {
            this.item.category_id = item.id
          }
        })


        KeplerBackofficeSdk.vehicles.select(this.item.id).edit(this.item, (data) => {
          MaggieHelper.notification('Edit', 'Vehicle edited successfully')
          MaggieHelper.closeRightPanel()
        })
      }
    },
    props: [
      'item'
    ]
  }
</script>
<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// VehicleEdit.vue?f5427758